// Sanitize filename while allowing hyphens and parentheses
export function sanitizeFileName(fileName: string): string {
  // Get file extension
  const ext = fileName.split('.').pop();
  
  // Clean the base name - allow letters, numbers, hyphens, parentheses and spaces
  const baseName = fileName.slice(0, -(ext?.length || 0) - 1)
    .replace(/[^a-zA-Z0-9\-\(\)\[\] ]/g, '_')
    .trim();

  // Return sanitized name with extension
  return `${baseName}.${ext}`;
}

// Validate file type
export function validateFileType(file: File, accept: string): boolean {
  if (accept === '.pdf') {
    return (
      file.type === 'application/pdf' || 
      file.name.toLowerCase().endsWith('.pdf')
    );
  }
  
  // Handle multiple accept values
  const acceptTypes = accept.split(',').map(type => type.trim());
  return acceptTypes.some(type => {
    if (type.startsWith('.')) {
      // Check file extension
      return file.name.toLowerCase().endsWith(type.toLowerCase());
    } else {
      // Check mime type
      return file.type.match(type.replace('*', '.*')) !== null;
    }
  });
}

// Format file size
function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}